var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/thumbs_up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-192.000000, -447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-4",
    transform: "translate(48.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Thumbs-Up",
    transform: "translate(144.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06249713,9.75 L2.93749934,9.75 C2.41972627,9.75 2,10.1697266 2,10.6875 L2,20.0625 C2,20.5802734 2.41972627,21 2.93749934,21 L6.06249713,21 C6.5802702,21 7,20.5802734 7,20.0625 L7,10.6875 C7,10.1697266 6.5802702,9.75 6.06249713,9.75 Z M4.49999823,19.4375 C3.98222516,19.4375 3.5624989,19.0177734 3.5624989,18.5 C3.5624989,17.9822266 3.98222516,17.5625 4.49999823,17.5625 C5.0177713,17.5625 5.43749757,17.9822266 5.43749757,18.5 C5.43749757,19.0177734 5.0177713,19.4375 4.49999823,19.4375 Z M16.9999894,4.18171875 C16.9999894,5.83859375 15.985537,6.76796875 15.7001075,7.875 L19.6736594,7.875 C20.9782288,7.875 21.993853,8.95882813 21.9999736,10.1444531 C22.003228,10.8451563 21.7051814,11.5994922 21.2406114,12.0662109 L21.2363145,12.0705078 C21.620533,12.9821094 21.5580721,14.2594531 20.872721,15.1747656 C21.2118224,16.1862891 20.8700257,17.4288281 20.2327996,18.0949609 C20.4006901,18.7823828 20.3204558,19.3674219 19.9926435,19.8383984 C19.1953785,20.9838672 17.2193642,21 15.5483889,21 L15.4372561,21 C13.5510465,20.9992969 12.0073367,20.3125391 10.7669469,19.7607031 C10.1436271,19.4833984 9.32862763,19.1401172 8.71026869,19.12875 C8.45480012,19.1240625 8.24999558,18.9155859 8.24999558,18.6600781 L8.24999558,10.3096875 C8.24999558,10.1846875 8.30007367,10.0647266 8.38897986,9.97683594 C9.93640064,8.44777344 10.6017908,6.82890625 11.8701102,5.5584375 C12.448391,4.9790625 12.6587034,4.10390625 12.8620236,3.25757812 C13.0357344,2.53488281 13.3990935,1 14.1874914,1 C15.1249907,1 16.9999894,1.3125 16.9999894,4.18171875 L16.9999894,4.18171875 Z",
    id: "Icon",
    fill: "#898F9E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.9b651902.svg";
export { ForwardRef as ReactComponent };